import Swiper, {  } from 'swiper';
import { Autoplay } from 'swiper/modules';

//import 'swiper/swiper-bundle.css';
import 'swiper/css/autoplay';

const logoSliderNetwork = document.querySelectorAll('.js-logos.autoplay-enabled .section-logos__logos .network');

const updatePartnersSliderWidth = () => {
  if (!logoSliderNetwork) return;
  logoSliderNetwork.forEach(slider => slider.style.width = `${slider.scrollWidth}px`);
}

window.addEventListener('load', () => {

  function initSliderMembers() {
    let logoSlider = document.querySelectorAll('.js-logos.swiper.members');
    if (logoSlider.length > 0) {
      logoSlider.forEach((element) => {
        const sliderItems = [...element.querySelectorAll('.section-logos__logo')];
        const speed = sliderItems.length * 1000;

        new Swiper(element, {
          modules: [Autoplay],
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          loop: true,
          centeredSlides: true,
          spaceBetween: 0,
          speed: speed,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },

          breakpoints: {
            768: {
              speed: speed,
              centeredSlides: false,
            },

            1024: {
              speed: speed,
              centeredSlides: false,
            },

            1440: {
              speed: 0,
              centeredSlides: false,
            },
          },
        });
      });
    }
  }

  initSliderMembers()
  updatePartnersSliderWidth();
});

window.addEventListener('resize', () => {
  setTimeout(() => {
    updatePartnersSliderWidth();
  }, 1000);
});
